// "The Quality Layer, Shipped (Not a Victory Lap)" — build-in-public enterprise-RAG short.
// Cold Compute / Neon kit. ~112s @ 30fps. Every on-screen claim is grounded in the
// EAKC-MVP achievements record docs/visual-companion/2026-07-19-eakc-achievements.html
// (commits + migrations) — see metadata.md GROUNDING NOTE. The honest last beat keeps
// this a status report, not a victory lap: the eval harness that will QUANTIFY the work
// is still being built, and the deeper P2/P3 retrieval work is deliberately deferred.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 150 }, //         0:00–0:05  shipped the quality layer — but can't prove it yet
  flaw: { start: 150, duration: 420 }, //       0:05–0:19  the fluent-but-flawed answer
  answers: { start: 570, duration: 570 }, //    0:19–0:38  four answer-checking layers, default-ON
  chat: { start: 1140, duration: 480 }, //      0:38–0:54  the transcript behaves (order/delete/cost/mermaid)
  quiz: { start: 1620, duration: 450 }, //      0:54–1:09  quizzes & learning paths stay grounded
  control: { start: 2070, duration: 480 }, //   1:09–1:25  operator control · Feature Switches
  honest: { start: 2550, duration: 480 }, //    1:25–1:41  what's shipped vs what's still being measured
  outro: { start: 3030, duration: 330 }, //     1:41–1:52
} as const;

export const TOTAL_DURATION = 3360; // 112s — verified contiguous sum below
// hook150 + flaw420 + answers570 + chat480 + quiz450 + control480 + honest480 + outro330 = 3360 (112s)

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
